var _PlayroomHistorySkele, _PlayroomHistoryEmpty;
import { useCallback, useLayoutEffect } from 'react';
import cn from 'clsx';
import { useRewardTransactions } from "../../../shared/hooks";
import { TransactionStatusEnum } from "../../../shared/types/graphql/globals.gamification";
import { RewardRequestedCard } from "../../components";
import { usePlayroomRewardsTranslations } from "../../hooks";
import PlayroomHistoryEmpty from "./components/PlayroomHistoryEmpty";
import PlayroomHistorySkeleton from "./components/PlayroomHistorySkeleton";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var PlayroomHistory = function PlayroomHistory() {
  var _usePlayroomRewardsTr = usePlayroomRewardsTranslations(),
    t = _usePlayroomRewardsTr.t;
  var _useRewardTransaction = useRewardTransactions(),
    transactions = _useRewardTransaction.data,
    loading = _useRewardTransaction.loading,
    refetchTransactions = _useRewardTransaction.refetch;
  var statusEnumToType = useCallback(function (transaction) {
    switch (transaction.current_status) {
      case TransactionStatusEnum.STATUS_DONE:
        return 'DELIVERED';
      case TransactionStatusEnum.STATUS_PENDING:
        return 'REQUESTED';
      default:
        return 'REQUESTED';
    }
  }, []);

  // Refetch transactions when the component is mounted
  // This only works using useLayoutEffect with refetchTransactions as a dependency
  // WARNING: Don't add more dependencies to this hook. It will cause an infinite loop.
  useLayoutEffect(function () {
    refetchTransactions();
  }, [refetchTransactions]);
  if (loading) {
    return _PlayroomHistorySkele || (_PlayroomHistorySkele = /*#__PURE__*/_jsx(PlayroomHistorySkeleton, {}));
  }
  if (transactions.length === 0) {
    return _PlayroomHistoryEmpty || (_PlayroomHistoryEmpty = /*#__PURE__*/_jsx(PlayroomHistoryEmpty, {}));
  }
  return /*#__PURE__*/_jsxs("section", {
    children: [/*#__PURE__*/_jsx("p", {
      className: "tw-font-body3 tw-mb-3.2",
      children: t('PRS_HISTORY_SECTION_DESCRIPTION')
    }), transactions.map(function (transaction, index) {
      var _transaction$reward$c;
      var isLast = index === transactions.length - 1;
      var status = statusEnumToType(transaction);
      return /*#__PURE__*/_jsx(RewardRequestedCard, {
        title: transaction.reward.name,
        coins: transaction.reward.currency_point_value || 0,
        imageSrc: (_transaction$reward$c = transaction.reward.cover_attachment) === null || _transaction$reward$c === void 0 ? void 0 : _transaction$reward$c.url,
        deliveryId: transaction.original_id,
        status: status,
        createdAt: transaction.created_at,
        className: cn('tw-border-b tw-border-solid', isLast ? 'tw-border-b-transparent' : 'tw-border-b-neutral-light-400 dark:tw-border-b-neutral-dark-600')
      }, transaction.original_id);
    })]
  });
};
export default PlayroomHistory;